export const CIRCLE_R = 19.5;
export const CIRCLE_CIRCUMFERENCE = 2 * Math.PI * CIRCLE_R;

export default (theme) => ({
    root: {
        width: 40,
        height: 40,
        border: `1px solid ${theme.colors.background.utility025}`,
        borderRadius: '50%',
        backgroundColor: theme.colors.primary.white,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        flexShrink: 0,
        transition: 'background-color 0.2s ease, border-color 0.2s ease',
        position: 'relative',
        '& .lf-player-container': {
            pointerEvents: 'none',
            position: 'absolute',
            top: -20,
            left: -20,
            width: 80,
            height: 80,
            zIndex: 0,
            opacity: 1,
            transition: 'opacity 0.2s ease',
        },
    },
    borderProgress: {
        pointerEvents: 'none',
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        '& circle': {
            stroke: theme.colors.actionMajor[500],
            strokeWidth: 1,
            fill: 'none',
            strokeDasharray: CIRCLE_CIRCUMFERENCE,
            /* strokeDashoffset is driven by the RAF animation in the component */
            transform: 'rotate(-90deg)',
            transformOrigin: 'center',
        },
    },
    hover: {
        borderColor: theme.colors.actionMajor[500],
        '& .lf-player-container': {
            opacity: 0.6,
        },
    },
    disabled: {
        cursor: 'auto',
    },
    icon: {
        position: 'relative',
        zIndex: 2,
    },
});
